import { render, staticRenderFns } from "./admincreate.vue?vue&type=template&id=0ecc02b1&"
import script from "./admincreate.vue?vue&type=script&lang=js&"
export * from "./admincreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports